import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Virgil from "./Virgil-Regular.woff2";

export const VirgilFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Virgil,
  },
];
